import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    "name": "salesstatusdescription",
    standalone: true
})
export class SalesStatusDescriptionPipe implements PipeTransform {
    transform (value: number): string {
        switch (value) {
            case 1:
                return "Pending";
            case 2:
                return "Signed";
            case 3:
                return "Approved";
            case 4:
                return "Rejected";
            case 5:
                return "Withdrawn";
            case 6:
                return "Out for Signature";
            default:
                return "";
        }
    }
}
